import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/v2/payment/invoice-adjustment'

export default {
  namespaced: true,
  state: {
    ...baseState,
    currencies: [],
    exchangeRates: [],
    paymentMethods: [],
    banks: [],
    feeTypes: []
  },
  mutations: {
    ...baseMutations,
    SET_CURRENCY(state, value) {
      state.currencies = value
    },
    SET_EXCHANGE_RATE(state, value) {
      state.exchangeRates = value
    },   
    SET_PAYMENT_METHOD(state, value) {
      state.paymentMethods = value
    },    
    SET_BANK(state, value) {
      state.banks = value
    },
    SET_FEE_TYPES(state, value) {
      state.feeTypes = value
    }
  },
  actions: {
    onGetInvoice(context, params) {
      return httpClient.get(`${BASE_URL}/invoices`, { params })
    },
    async onGetCurrency(context) {
      const response = await httpClient.get(`${BASE_URL}/currencies`)
      context.commit('SET_CURRENCY', response.data.data)
    }, 
    async onGetExchangeRate(context) {
      const response = await httpClient.get(`${BASE_URL}/exchange-rates`)
      context.commit('SET_EXCHANGE_RATE', response.data.data)
    },
    async onGetPaymentMethod(context) {
      const response = await httpClient.get(`${BASE_URL}/payment-methods`)
      context.commit('SET_PAYMENT_METHOD', response.data.data)
    },       
    async onGetBank(context) {
      const response = await httpClient.get(`${BASE_URL}/banks`)
      context.commit('SET_BANK', response.data.data)
    },       
    async onGetFeeType(context) {
      const response = await httpClient.get(`${BASE_URL}/fee-types`)
      context.commit('SET_FEE_TYPES', response.data.data)
    },    
    onGetAcademicClass(context, params) {
      return httpClient.get(`${BASE_URL}/classes`, { params })
    },    
    onGetFeeItems(context, params) {
      return httpClient.get(`${BASE_URL}/fee-items`, { params })
    },    
    show(context, id) {
      return httpClient.get(`${BASE_URL}/${id}`)
    },
    onSave(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    },
  }
}
